import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '@contexts/AppContext';
import { SubscribeFormProvider } from '@contexts/SubscribeFormContext';
import { User } from '@utils/backend-api/currentUser';
import { OfferOption, SelectedOffer } from '@utils/backend-api/subscribe';

import MultipleOffers from './MultipleOffers';
import SingleOffer from './SingleOffer';

const queryClient = new QueryClient();

export interface SubscribeProps {
  defaultSelectedOffer: SelectedOffer;
  description?: string;
  dob: string;
  initialCurrentUser?: User;
  isGdprRequired: boolean;
  isUserCBPT?: boolean;
  offers: OfferOption[];
  stripeCustomerId?: string;
  userEmail?: string;
  userFullName?: string;
  userNextBillingDate?: string;
}

const Subscribe = ({
  defaultSelectedOffer,
  description,
  dob,
  initialCurrentUser,
  isGdprRequired,
  isUserCBPT,
  offers,
  stripeCustomerId,
  userEmail,
  userFullName,
  userNextBillingDate,
}: SubscribeProps) => {
  const isSingleOffer = offers.length === 1;

  return (
    <AppContextProvider initialCurrentUser={initialCurrentUser} isGdprRequired={isGdprRequired}>
      <SubscribeFormProvider
        user={{
          dob,
          email: userEmail,
          isUserCBPT,
          name: userFullName,
          nextBillingDate: userNextBillingDate,
          stripeCustomerId,
        }}
      >
        <QueryClientProvider client={queryClient}>
          {isSingleOffer ? (
            <SingleOffer description={description} offer={offers[0]} />
          ) : (
            <MultipleOffers
              defaultSelectedOffer={defaultSelectedOffer}
              description={description}
              offers={offers}
            />
          )}
        </QueryClientProvider>
      </SubscribeFormProvider>
    </AppContextProvider>
  );
};

export default Subscribe;
